import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=9f70a7ae"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f70a7ae')) {
      api.createRecord('9f70a7ae', component.options)
    } else {
      api.reload('9f70a7ae', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=9f70a7ae", function () {
      api.rerender('9f70a7ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/cooperative/edit.vue"
export default component.exports